import Page from 'flarum/common/components/Page';

export default class PageContent extends Page {
    oninit(){
        this.test = '';
        this.content = (
            <>
                {/* <head>
                    <title>Subscribe to a cool new product</title>
                    <link rel="stylesheet" href="style.css" />
                    <script src="https://polyfill.io/v3/polyfill.min.js?version=3.52.1&features=fetch"></script>
                    <script src="https://js.stripe.com/v3/"></script>
                </head> */}
 
                <div id="stripe-body">
                    <div class='subscribe-heading'>
                        <h1>Choose Your Plan</h1>
                        <p>Sign up and get access to all the amazing perks and features of the Clubhouse</p>
                    </div>
                    {/* <img src={app.forum.attribute('baseUrl') + '/assets/subscription-background.png'} /> */}
                    <img src={app.forum.attribute('baseUrl') + '/assets/' + app.forum.attribute('morphdev.stripe-bg-image')} />
                    <div class='plan-selection'>
                        <section id="checkout-form">
                            <div class="product">
                                <div id="bullet-point">
                                    <div class="content-heading">
                                        <h2 class="bullet-titl">Clubhouse Membership Benefits Include:</h2>
                                    </div>
                                    <div class="bullet" style="color: white; list-style: none;">
                                        <li>Private message board</li>
                                        <li>24 hour early access to auctions</li>
                                        <li>Ability to pay with your Donor Advised Fund</li>
                                        <li>Invitations to Clubhouse Only Events</li>
                                        <li>Early Access to all other Member for a Day events</li>
                                        <li>Preferred Partner Discounts</li>

                                        <li>Direct booking for rounds at select courses from our host network</li>
                                        <li>20% off Member for a Day Merchandise (coming soon)</li>
                                        <li>Dedicated Clubhouse Customer Service</li>
                                        <li>Crystal Ball View (see upcoming auctions)</li>
                                        <li>Dormie Network Partnership</li>
                                        <li>Annual Gift</li>
                                    </div>
                                </div>
                                    <div class="description">
                                    <h2>Clubhouse Membership</h2>
                                    <h3>$99 / Month</h3>
                                    </div>
                                <form action="/create-checkout-session" method="POST">
                                    {/* Add a hidden field with the lookup_key of your Price  */}
                                    {/* <input type="hidden" name="lookup_key" value="monthly" /> */}
                                    <input type="hidden" name="subscription_type" value="monthly" />
                                    <button id="checkout-and-portal-button" type="submit" >Signup</button>
                                    <div>{this.test}</div>
                                </form>
                            </div>
                        </section>
                        <section id="checkout-form">
                                <div class="product">
                                    <div id="bullet-point">
                                        <div class="content-heading">
                                            <h2 class="bullet-titl">Clubhouse Membership Benefits Include:</h2>
                                        </div>
                                        <div class="bullet" style="color: white; list-style: none;">
                                            <li>Private message board</li>
                                            <li>24 hour early access to auctions</li>
                                            <li>Ability to pay with your Donor Advised Fund</li>
                                            <li>Invitations to Clubhouse Only Events</li>
                                            <li>Early Access to all other Member for a Day events</li>
                                            <li>Preferred Partner Discounts</li>

                                            <li>Direct booking for rounds at select courses from our host network</li>
                                            <li>20% off Member for a Day Merchandise (coming soon)</li>
                                            <li>Dedicated Clubhouse Customer Service</li>
                                            <li>Crystal Ball View (see upcoming auctions)</li>
                                            <li>Dormie Network Partnership</li>
                                            <li>Annual Gift</li>
                                        </div>
                                    </div>
                                    <div class="description">
                                    <h2>Clubhouse Membership</h2>
                                    <h3>$999 / Year</h3>
                                    </div>
                                <form action="/create-checkout-session" method="POST">
                                    {/* Add a hidden field with the lookup_key of your Price  */}
                                    {/* <input type="hidden" name="lookup_key" value="monthly" /> */}
                                    <input type="hidden" name="subscription_type" value="yearly" />
                                    <button id="checkout-and-portal-button" type="submit" >Signup</button>
                                    <div>{this.test}</div>
                                </form>
                            </div>
                        </section>
                    </div>
          
                    <script>
            
                    </script>
                </div>
            </>
        )
    }


    view() {
        return this.content;
    }
}
